/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-13",
    versionChannel: "nightly",
    buildDate: "2025-04-13T00:30:47.767Z",
    commitHash: "2e41707e38ef33262f2e861e87ec08864957bc1b",
};
